import { Injectable } from '@angular/core';
import { NotesService } from './notes.service';

@Injectable({
  providedIn: 'root'
})
export class ChordsService {

  public intervalsDisplay = [
    'R', 'b2', '2', 'b3',
    '3', '4', 'b5', '5',
    '#5', '6', 'b7', '7',
    'T', 'b9', '9', '#9',
    'b11', '11', '#11', '',
    'b13', '13', '#13', ''
  ];
  public intervalsDisplayLong = [
    'Root', 'Flat 2nd', '2nd', 'Minor third',
    'Major third', 'Fourth', 'Dim. fifth', 'Fifth',
    'Augm. fifth', 'Sixth', 'Minor 7th', '7th',
    'Octave', 'Dim. ninth', 'Ninth', 'Augm. ninth',
    'Flat 11th', 'Eleventh', 'Augm. 11th', '',
    'Dim. 13th', '13th', 'Sharp 13th', ''
  ];
  public structures: { [name: string]: number[] } = {
    // 'commons':
        major         : [0, 4, 7],
        minor         : [0, 3, 7],
        ' 7'            : [0, 4, 7, 10],
        maj7          : [0, 4, 7, 11],
        m7            : [0, 3, 7, 10],
        'm(maj7)'       : [0, 3, 7, 11],
        'augm.'         : [0, 4, 8],
        'dimin.'        : [0, 3, 6],
        sus4          : [0, 5, 7],
        sus2          : [0, 2, 7],
    // 'chords7th' :
        '7 b5'          : [0, 4, 6, 10], 
        '7 #5'          : [0, 4, 8, 10],
        'maj7 b5'       : [0, 4, 6, 11],
        'maj7 #5'       : [0, 4, 8, 11],
        '7 b5 b9'       : [0, 4, 6, 10, 13],
        '7 b5 #9'       : [0, 4, 6, 10, 15],
        '7 #5 b9'       : [0, 4, 8, 10, 13],
        '7 #5 #9'       : [0, 4, 8, 10, 15],
        'm7 b5'         : [0, 3, 6, 10],
        'o maj7'        : [0, 3, 6, 11],
        'm7 #5'         : [0, 3, 8, 10],
        'm7 b9'         : [0, 3, 7, 10, 13],
        '7 b9'          : [0, 4, 7, 10, 13],
        '7 #9'          : [0, 4, 7, 10, 15],
        '7 sus4'        : [0, 5, 7, 10],
        'maj7 sus4'     : [0, 5, 7, 11],
        dim7          : [0, 3, 6, 9],
    // 'chords9th':
        ' 9'            : [0, 4, 7, 10, 14],
        m9            : [0, 3, 7, 10, 14],
        maj9          : [0, 4, 7, 11, 14],
        'm(maj9)'       : [0, 3, 7, 11,  14],
        '9 sus4'        : [0, 5, 7, 10, 14],
        'maj9 sus4'     : [0, 5, 7, 11,  14],
        '9 #11'         : [0, 4, 7, 10, 14, 18],
        '9 b13'         : [0, 4, 7, 10, 14, 20],
        add9          : [0, 4, 7, 14],
        'm add9'         : [0, 3, 7, 14],
    // '11and13':
        'dom7 add11'    : [0, 4, 7, 10, 17], // Dominant 7 add 11
        'm7 add11'      : [0, 3, 7, 10, 17], // Minor 7 add 11
        'maj7 add11'    : [0, 4, 7, 11, 17], // Major 7 add 11
        'm(maj7) add11' : [0, 3, 7, 11, 17], // Minor major 7 add 11
        'dom7 add13'    : [0, 4, 7, 10, 21], // Dominant 7 add 13
        'm7 add13'      : [0, 3, 7, 10, 21], // Minor 7 add 13
        'maj7 add13'    : [0, 4, 7, 11, 21], // Major 7 add 13
        'm(maj7) add13' : [0, 3, 7, 11, 21], // Minor major 7 add 13
        ' 11'           : [0, 4, 7, 10, 14, 17],
        m11           : [0, 3, 7, 10, 14, 17],
        maj11         : [0, 4, 7, 11, 14, 17], // major 11
        'm(maj11)'      : [0, 3, 7, 11, 14, 17], // Minor major 11
        ' 13'           : [0, 4, 7, 10, 14, 21],
        m13           : [0, 3, 7, 10, 14, 21], // minor 13
        maj13         : [0, 4, 7, 11, 14, 21], // major 13
        'm(maj13)'      : [0, 3, 7, 11, 14, 21], // Minor major 13
        'dom. 13'       : [0, 4, 7, 10, 14, 17, 21],
        '#9 b13'        : [0, 4, 7, 10, 15, 17, 20],
    // 'other':
        ' 5'            : [0, 7],
        b5            : [0, 4, 6],
        'b5 #9'         : [0, 4, 6, 15],
        'b5 b9'         : [0, 4, 6, 13],
        ' 6'            : [0, 4, 7, 9],
        m6            : [0, 3, 7, 9],
        '6 add9'         : [0, 4, 7, 9, 14],
        'm6 add9'        : [0, 3, 7, 9, 14],
        '6 sus4'         : [0, 5, 7, 9],
        'm7 sus4'        : [0, 5, 10, 15],
    };
    public byFamily: {[index: string]:string[]} = {
      commons: [
        'major',
        'minor',
        ' 7',
        'maj7',
        'm7',
        'm(maj7)',
        'augm.',
        'dimin.',
        'sus4',
        'sus2',
      ],
      chords7th: [
        '7 b5',
        '7 #5',
        'maj7 b5',
        'o maj7',
        'maj7 #5',
        '7 b5 b9',
        '7 b5 #9',
        '7 #5 b9',
        '7 #5 #9',
        'm7 b5',
        'm7 #5',
        'm7 b9',
        '7 b9',
        '7 #9',
        '7 sus4',
        'maj7 sus4',
        'dim7'
      ],
      chords9th: [
        ' 9',
        'm9',
        'maj9',
        'm(maj9)',
        '9 sus4',
        'maj9 sus4',
        '9 #11',
        '9 b13',
        'add9',
        'm add9',
      ],
      '11and13': [
        'dom7 add11',
        'm7 add11',
        'maj7 add11',
        'm(maj7) add11',
        'dom7 add13',
        'm7 add13',
        'maj7 add13',
        'm(maj7) add13',
        ' 11',
        'm11',
        'maj11',
        'm(maj11)',
        ' 13',
        'm13 ',
        'maj13',
        'm(maj13)',
        'dom. 13',
        '#9 b13',
      ],
      other: [
        ' 5',
        'b5',
        'b5 #9',
        'b5 b9',
        ' 6',
        'm6',
        '6 add9',
        'm6 add9',
        '6 sus4',
        'm7 sus4',
      ]
    };
    public synonyms = {
      major         : ['majeur', 'maj'],
      minor         : ['mineur', 'min'],
      ' 7'            : ['7th', 'senventh', 'septième'],
      maj7          : ['major 7', 'majeur 7', 'major 7th', 'majeur 7ème'],
      m7            : ['minor 7', 'mineur 7', 'minor 7th', 'mineur 7ème'],
      'm(maj7)'       : ['minor maj7', 'mineur maj7'],
      '7 b5'          : ['dom7 b5', '7 5-', 'dom7 5-', 'septième b5', 'septième 5-'],
      '7 #5'          : ['dom7 #5', '7 5+', 'dom7 5+', 'septième #5', 'septième 5+', 'augmented 7th'],
      'maj7 b5'        : ['major7 5-', 'maj7 5-', 'major7 b5'],
      '7 #5 b9'       : ['7 5+ 9-', '7th #5 b9', '7th 5+ 9-', 'septième #5 b9', 'septième 5+ 9-', 'septième #5 b9', 'septième 5+ 9-'],
      'm7 b5'         : ['minor7 b5', 'minor7 5-', 'm7 5-', 'mineur7 b5', 'mineur7 5-'],
      'm7 #5'         : ['minor7 #5', 'minor7 5+', 'm7 5+', 'mineur7 #5', 'mineur7 5+'],
      '7 b9'          : ['dom7 b9', '7 9-', 'dom7 9-', 'septième b9', 'septième 9-'],
      'm7 b9'         : ['minor7 b9', 'minor7 9-', 'm7 9-', 'mineur7 b9', 'mineur7 9-'],
      '7 #9'          : ['dom7 #9', '7 9+', 'dom7 9+', 'septième #9', 'septième 9+'],
      '7 sus4'        : [],
      'maj7 sus4'     : ['major 7 sus4', 'major 7th sus4', 'majeur 7ème sus4'] ,
      ' 9'            : ['ninth', 'neuvième', '9th', '9ème', 'nine', 'neuf'],
      m9            : ['minor ninth', 'mineur neuvième', 'minor 9th', 'mineure 9ème'],
      maj9          : ['major ninth', 'majeur neuvième', 'major 9th', 'majeur 9ème'],
      'm(maj9)'       : ['minor major9', 'mineur majeur9'],
      '9 sus4'        : ['ninth sus4', 'neuvième sus4', '9th sus4', '9ème sus4'],
      'maj9 sus4'     : ['major ninth sus4', 'majeur neuvième sus4', 'major 9 sus4', 'major 9th sus4', 'majeur 9ème sus4'],
      '9 #11'         : ['9 eleventh+'],
      '9 b13'         : [],
      ' 6'            : ['sixte', 'sixième', '6ème'],
      m6            : ['minor sixte', 'mineur sixième', 'mineur 6ème'],
      '6add9'         : ['6/9', 'sixte add9', 'sixième add9'],
      '6sus4'         : ['sixte sus4', 'sixième sus4'],
      'dom7 add11'    : ['dominant 7 add11'],
      'm7 add11'      : ['minor 7 add11', 'mineur 7 add11', 'minor 7th add11', 'mineur 7ème add11'],
      'maj7 add11'    : ['major 7 add11'],
      'm(maj7) add11' : ['minor major 7 add11'],
      'dom7 add13'    : ['dominant 7 add 13'],
      'm7 add13'      : ['minor 7 add 11'],
      'maj7 add13'    : ['major 7 add13'],
      'm(maj7) add13' : ['minor major 7 add13'],
      ' 11'           : ['eleventh', '11ème', 'onzième', 'dominant 11'],
      m11           : ['minor eleventh', 'mineur 11ème', 'mineur onzième'],
      maj11         : ['major eleventh', 'majeur 11ème', 'majeur onzième'],
      'm(maj11)'      : ['minor major 11'],
      ' 13'           : [],
      m13           : ['minor 13', 'mineur 13'],
      maj13         : ['major 13', 'majeur 13'],
      'm(maj13)'      : ['minor major 13', 'mineur majeur 13'],
      'dom. 13'       : ['dominant 13'],
      ' 5'            : ['power', 'puissance', 'quinte'],
      'augm.'         : ['augmented', 'augmenté'],
      'dimin.'        : ['diminished', 'diminué'],
      sus4          : ['suspended 4'],
      sus2          : ['suspended 2'],
      add9          : [],
      madd9         : ['minor add9'],
      dim7          : ['diminished 7th'],
      m7sus4        : ['So what']
  };
  constructor(
    public notesService: NotesService
  ) { }

  getStructure(name: string): number[] {
    const s = this.structures[name];
    if (typeof(s) === 'undefined') {
      console.log('ERROR: chord "' + name + '" not found.');
      return [];
    }
    return s;
  }
  getInversionStructure(name: string, inversion: number) {
    if ((typeof inversion === 'undefined') ||
        (inversion === 0)) {
      return this.getStructure(name);
    }
    const result: number[] = [];
    this.getStructure(name).forEach((offset, index) => {
      if (((index === 1) && (inversion === 1)) ||
          ((index === 2) && (inversion === 1)) ||
          ((index === 2) && (inversion === 2)) ||
          ((index === 3) && (inversion === 3))) {
        offset -= 12;
      }
      result.push(offset);
    });
    return result;
  }
  getShortName(longName: string): string {
    if (longName === 'major') {
      return '';
    } else if (longName === 'minor') {
      return 'm';
    } else if (longName === ' 7') {
      return '7';
    } else if (longName === ' 6') {
      return '6';
    } else if (longName === 'augm.') {
      return 'aug';
    } else if (longName === 'dimin.') {
      return 'dim';
    } else if (longName === 'm7 b5') {
      return 'm7b5';
    }
    return longName;
  }
  getLongName(shortName: string): string {
    if (shortName === '') {
      return 'major';
    } else if (shortName === 'm') {
      return 'minor';
    } else if (shortName === '7') {
      return ' 7';
    } else if (shortName === '6') {
      return ' 6';
    } else if (shortName === 'aug') {
      return 'augm.';
    } else if (shortName === 'dim') {
      return 'dimin.';
    } else if (shortName === 'm7b5') {
      return 'm7 b5';
    }
    return shortName;
  }
  getNames() {
    const result: string[] = [];
    for (const name in this.structures) {
      if (this.structures.hasOwnProperty(name)) {
        result.push(name);
      }
    }
    return result;
  }
  getIntervals(name: string) {
    const result: string[] = [];
    this.structures[name].forEach((int) => {
      result.push(this.intervalsDisplay[int]);
    });
    return result;
  }
  getIntervalName(
    root12: number,
    chordName: string,
    note12: number
  ) {
    const intervalstab = ['T', '9-', '9', '3-', '3', '11', '5-', '5', '5+', '13', '7-', '7'];
    if (chordName.indexOf('sus2') !== -1) { intervalstab[2] = '2'; }
    if (chordName.indexOf('sus4') !== -1) { intervalstab[5] = '4'; }
    if (chordName.indexOf('6') !== -1) { intervalstab[9] = '6'; }
    if (chordName.indexOf('#9') !== -1) { intervalstab[3] = '9+'; }
    if (chordName.indexOf('b13') !== -1) { intervalstab[8] = '13-'; }
    if (chordName.indexOf('#11') !== -1) { intervalstab[6] = '11+'; }
    if (chordName.indexOf('dim7') !== -1) { intervalstab[9] = '6'; }
    return intervalstab[(note12 + 12 - root12) % 12];
  }
  getRelativeChord(note: string, chord: string, doremi: boolean): {
    relativeNote: string,
    relativeChord: string
  } | null {
    if (['major', 'minor'].indexOf(chord) === -1) {
      return null;
    }
    const relativeNote = this.notesService.getStrictNoteName(
      note,
      (chord === 'major') ? 5 : 2,
      (chord === 'major') ? 9 : 3,
      doremi
    );
    const relativeChord = (chord === 'major') ? 'minor' : 'major';
    return {
      relativeNote,
      relativeChord
    };
  }
}

